import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const CONTAINER_LIVE_MIGRATION_DETAIL_QUERY_KEY =
  'container-live-migration-detail';

const getContainerLiveMigrationDetailQueryKey = (params: {
  organizationId: string;
  clusterId: string;
  migrationId: string;
}) =>
  [
    CONTAINER_LIVE_MIGRATION_DETAIL_QUERY_KEY,
    params.organizationId,
    params.clusterId,
    params.migrationId,
  ] as const;

const getContainerLiveMigrationDetailQueryOptions = (params: {
  organizationId: string;
  clusterId: string;
  migrationId: string;
}) =>
  queryOptions({
    queryKey: getContainerLiveMigrationDetailQueryKey(params),
    queryFn: async () => {
      const { data } =
        await apiClient.costReport.getContainerLiveMigrationDetail(params);
      return data;
    },
  });

export const useContainerLiveMigrationDetailQuery = (params: {
  organizationId: string;
  clusterId: string;
  migrationId: string;
}) => {
  return useQuery(getContainerLiveMigrationDetailQueryOptions(params));
};
